import { Component, OnInit } from '@angular/core';
import { ITab } from '@koomzo/coremodel';
import { Store } from '@ngxs/store';

@Component({
    template: `
  <kz-tabs [model]="tabList"></kz-tabs>
  `,
    styles: [],
    standalone: false
})
export class IndexComponent implements OnInit {
  tabList: ITab[];

  constructor(private _store: Store) {}

  ngOnInit() {
    console.log('tags module created');
    this.tabList = [
      {
        label: 'Manage Tags',
        path: 'home',
        icon: 'pricetags',
        displayOrder: 1
      },
      {
        label: 'Stats & Reports',
        path: 'stats',
        icon: 'analytics',
        displayOrder: 2
      }
    ];
  }
}
